module.exports = __webpack_public_path__ + "h.no1.fb4abcd6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/h.no1.jpg
// module id = 2Hhf
// module chunks = 0